export default __webpack_public_path__ + "static/media/program_1.280439cb.jpg";